import { DELETE, VIEW } from "./constants";

export default function handleMapDrag(info, event, deckRef, drawMode, drawnFeaturesDispatch) {
  if (drawMode !== VIEW && drawMode !== DELETE) {
    // find the feature within click radius
    // find closest point on the geometry
    // move the 
    return true
  }
}